<template>
  <div id="page-about-us" class="w-full px-5 pb-5 bg-white md:pt-4">
    <h1 class="text-3xl py-6">{{ $t('static.about_us.title') }}</h1>
    <div class="content text-article whitespace-pre-wrap">
      <div v-html="$t('static.about_us.content')"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'static',
})
</script>
